import styled from 'styled-components'

// This component is made to display an image within a fixed height and always preserving its ratio regardless or how it fits the width
export const SmartImage = styled.div<any>`
  height: ${({ height }) => height};
  background-image: url(${({ imgSrc }) => imgSrc});
  background-position: center;
  background-size: cover;
`
